
export class LoginForm {
    constructor(private _email: string,
        private _password: string) { }
}